/**
 * Hook tải danh sách BĐS yêu thích của người dùng đã đăng nhập.
 *
 * Tự động fetch khi mount; cung cấp reloadFavorites để làm mới thủ công.
 */
import { useCallback, useEffect, useState } from 'react';
import { favoriteApi } from '../api/favoriteApi';

/**
 * Quản lý state danh sách yêu thích và trạng thái loading.
 * @returns {{
 *   favoriteItems: Array,
 *   isLoadingFavorites: boolean,
 *   reloadFavorites: Function,
 * }}
 */
export const useFavoriteProperties = () => {
  const [favoriteItems, setFavoriteItems] = useState([]);
  const [isLoadingFavorites, setIsLoadingFavorites] = useState(true);

  const loadFavorites = useCallback(() => {
    setIsLoadingFavorites(true);

    return favoriteApi
      .getFavorites()
      .then((response) => {
        setFavoriteItems(response.data.data || []);
      })
      .catch(() => {
        setFavoriteItems([]);
      })
      .finally(() => {
        setIsLoadingFavorites(false);
      });
  }, []);

  useEffect(() => {
    loadFavorites();
  }, [loadFavorites]);

  return {
    favoriteItems,
    isLoadingFavorites,
    reloadFavorites: loadFavorites,
  };
};
